<template>
  <div
    class="expandable-control"
    :class="isOpen ? 'expanded' : 'collapsed'"
    @click="toggle"
  >
    {{ text }} <i :class="[icon]"></i>
  </div>
</template>

<script>
export default {
  name: 'ExpandableControl',
  data() {
    return {
      isOpen: false
    }
  },
  props: {
    openText: {
      type: String,
      required: false,
      default: null
    },
    closeText: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
      this.$emit('toggle', this.isOpen)
    }
  },
  computed: {
    text() {
      return this.isOpen
        ? this.closeText || this.$t('ExpandableControl_Close')
        : this.openText || this.$t('ExpandableControl_Open')
    },
    icon() {
      return this.isOpen ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    }
  }
}
</script>

<style scoped lang="scss">
.expandable-control {
  cursor: pointer;
  border-top: 1px solid #dbdee7;
  height: 44px;
  line-height: 44px;
  text-align: center;

  &:hover {
    color: #409eff;
    background-color: #f9fafc;
  }
}

.expandable-el-card {
  margin: 0 -20px;
  margin-bottom: -20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/analytics/components/ExpandableControl.vue